import { styled } from '@mui/system';
import { generateActivityTypeColors } from 'src/utils/colors';

import { getPriorityIcons } from '../../Piority/PriorityIcons';

import WrapperActivity, { WrapperActivityProps } from './WrapperActivity';

export enum PriorityTypes {
  Low = 1,
  Normal = 2,
  High = 3,
}

export const ActivityEvent = styled(
  ({ ...props }: Omit<WrapperActivityProps, 'icon'>) => (
    <WrapperActivity
      {...props}
      title={props.title}
      priority={props.priority}
      icon={getPriorityIcons(props.priority)}
    />
  ),
)(({ title, typeid }) => ({
  border: '1px solid',
  ...generateActivityTypeColors(typeid, title),
  cursor: 'pointer',
}));

export default ActivityEvent;
